
/* injects from baggage-loader */

import React from 'react'
import {connect} from 'react-redux'
import {closeModal} from 'redux/modules/ui/modal/actions'
import {updateSubscription} from 'redux/modules/billing/actions'
import formatDate from 'date-fns/format'
import NumberFormat from 'components/NumberFormat'
import Confirm from 'components/Confirm'

const getCouponMessage = coupon => {
  if (!coupon) return null

  const percentageDiscount = coupon.percent_off / 100
  return (
    <span>
      {' '}
      (with discount <NumberFormat
        value={percentageDiscount}
        format='percent' />)
    </span>
  )
}

const getTrialAmount = (amount, currency, coupon) => {
  if (coupon && coupon.percent_off) {
    return (
      <span>
        <NumberFormat
          value={(amount - amount * (coupon.percent_off / 100)) / 100}
          format='currency'
          currency={currency.toUpperCase()}
        />/mo.
        {getCouponMessage(coupon)}
      </span>
    )
  }

  return (
    <span>
      <NumberFormat
        value={amount / 100}
        format='currency'
        currency={currency.toUpperCase()}
      />/mo.
    </span>
  )
}

const getMessage = (planPreview, merchant, plan) => {
  const {id, name, currency, amount} = plan

  if (id === 'enterprise') {
    return (
      <div>
        You can start using Data-Driven without any limitations right after the subscription.
        {' '}
        Shortly after, Data-Driven representative will contact you and discuss usage conditions.
      </div>
    )
  }

  if (!planPreview) return null
  const {trial} = merchant
  const {trialEndDate, coupon} = planPreview

  if (!trial && trialEndDate) {
    return (
      <div>
        Your trial will be from {formatDate(planPreview.periodStart, 'MMMM D, YYYY')}
        {' '}
        to {formatDate(trialEndDate, 'MMMM D, YYYY')}.
        {' '}
        After that you'll be subscribed to our {name} plan and charged
        {' '}
        {getTrialAmount(amount, currency, coupon)}
      </div>
    )
  } else if (trial && trialEndDate) {
    return (
      <div>
        Your trial will be active until {formatDate(trialEndDate, 'MMMM D, YYYY')}.
        {' '}
        After that you'll be upgraded/downgraded to our {name} plan and charged
        {' '}
        {getTrialAmount(amount, currency, coupon)}
      </div>
    )
  } else {
    const couponMessage = getCouponMessage(coupon)
    return (
      <div>
        You will be charged <NumberFormat
          value={planPreview.total}
          format='currency'
          currency={planPreview.currency}
        /> on {formatDate(planPreview.periodEnd, 'MMMM D, YYYY')}
        {couponMessage}.
        Click below to confirm.
      </div>
    )
  }
}

export default connect((state, {plan, merchant}) => {
  const {planPreview, planPreviewFetching, invoicePreviewError} = state.billing
  const {name} = plan
  const {trial} = merchant

  return {
    className: 'subscription-confirm',
    error: invoicePreviewError,
    message: getMessage(planPreview, merchant, plan),
    loading: planPreviewFetching,
    ok: trial ? `Start trial with ${name} plan` : `Subscribe to ${name}`,
    okClassName: 'is-blue',
    cancel: 'Close'
  }
}, (dispatch, {plan}) => {
  const {id} = plan
  const dispatchCloseModal = () => dispatch(closeModal())

  return {
    onOk: () => dispatch(updateSubscription(id))
      .success(dispatchCloseModal)
      .fail(dispatchCloseModal),
    onCancel: dispatchCloseModal
  }
})(Confirm)



// WEBPACK FOOTER //
// ./client/modals/UpdateSubscriptionConfirm/index.js